import stylesheet from './x-search-facet-title.component.scss?as=stylesheet';
import {html, nothing, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import 'extensions/g-modal';
import {defineCustomElement} from 'extensions/utils';

export class FacetTitle extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			collapsible: {
				type: Boolean
			},
			label: {
				type: String
			},
			open: {
				type: Boolean
			},
			tooltip: {
				type: String
			},
			type: {
				type: String
			}
		};
	}

	constructor () {
		super();

		this.collapsible = false;
		this.label = '';
		this.open = false;
		this.tooltip = '';
		this.type = '';
	}

	renderTooltip () {
		if (!this.tooltip) {
			return nothing;
		}

		return html`<g-modal small="true">
			<button class="tooltip" slot="trigger">Learn More</button>
			<div class="tooltip-title" slot="title">${this.label}</div>
			<div slot="content">${this.tooltip}</div>
		</g-modal>`;
	}

	renderLabel () {
		return html`
			<div class="label">
				<div class="label-text">
					${this.label}
					${this.collapsible ? html`<span class="summary-icon icon-caret--up"></span>` : ''}
				</div>
				${this.renderTooltip()}
			</div>
		`;
	}

	renderContent () {
		if (this.collapsible) {
			return html`
				<details ?open="${this.open}">
					<summary>${this.renderLabel()}</summary>
					<slot></slot>
				</details>
			`;
		}

		return html`
			${this.renderLabel()}
			<slot></slot>
		`;
	}

	render () {
		const classes = {
			container: true,
			[`type--${this.type}`]: true
		};

		return html`<div class="${classMap(classes)}">
			${this.renderContent()}
		</div>`;
	}
};

defineCustomElement('x-search-facet-title', FacetTitle);
